import { render, staticRenderFns } from "./RetentionReleaseTeamModal.vue?vue&type=template&id=465dc4b2&scoped=true&"
import script from "./RetentionReleaseTeamModal.vue?vue&type=script&lang=js&"
export * from "./RetentionReleaseTeamModal.vue?vue&type=script&lang=js&"
import style0 from "./RetentionReleaseTeamModal.vue?vue&type=style&index=0&id=465dc4b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465dc4b2",
  null
  
)

export default component.exports